<template>
  <v-select
    :value="value"
    :dir="isRtl ? 'rtl' : 'ltr'"
    :options="options"
    :clearable="clearable"
    :disabled="disabled || loading"
    :loading="loading"
    :placeholder="placeholder"
    :filter="filterAccounts"
    :get-option-label="optionLabel"
    :reduce="val => val.id"
    class="w-100 ledger-account-select"
    @input="$emit('input', $event)"
  >
    <template #no-options>
      {{ loading ? $t('common.loading') : $t('noMatching') }}
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select'
import { accountOptionLabel } from '@/utils/ledger'

export default {
  name: 'GlAccountSelect',
  components: { vSelect },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    accounts: {
      type: Array,
      default: () => [],
    },
    postingOnly: {
      type: Boolean,
      default: false,
    },
    excludeIds: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRtl() {
      return this.$store.state.appConfig.layout.isRTL
    },
    options() {
      return (this.accounts || []).filter(account => {
        if (this.excludeIds.includes(account.id)) return false
        if (this.postingOnly) {
          return account.accepts_posting && account.is_active
        }
        return true
      })
    },
  },
  methods: {
    optionLabel(account) {
      return accountOptionLabel(account, this.$i18n.locale)
    },
    filterAccounts(options, search) {
      const q = (search || '').trim().toLowerCase()
      if (!q) return options
      const prefixed = []
      const named = []
      options.forEach(account => {
        const code = String(account.code || '').toLowerCase()
        const name = String(account.name || '').toLowerCase()
        const nameEn = String(account.name_en || '').toLowerCase()
        if (code.startsWith(q)) prefixed.push(account)
        else if (code.includes(q) || name.includes(q) || nameEn.includes(q)) named.push(account)
      })
      return [...prefixed, ...named]
    },
  },
}
</script>
